interface ChartEmptyStateProps {
  message: string;
  height?: number;
}

export function ChartEmptyState({ message, height = 300 }: ChartEmptyStateProps) {
  return (
    <div className="flex h-full items-center justify-center text-gray-500" style={{ height }}>
      <p className="text-sm">{message}</p>
    </div>
  );
}
